// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_Dnk","cls2":"Accordion-cls2_QHF Accordion-cls1_Dnk"};